import { thinLabel } from "services/api/dashboard/range";

interface AxisLabelsProps {
  labels: string[];
  className?: string;
  /** Iznad ovoliko bucketa prikaži samo prvu i zadnju oznaku (početak/kraj razdoblja). */
  denseThreshold?: number;
}

/**
 * Oznake x-osi za dashboard grafove. Kod gustih raspona (npr. 30 dnevnih bucketa) prikazuje
 * samo početnu i završnu oznaku umjesto da zbija sve datume; inače prorijedi na ~6 oznaka.
 * Renderira spanove izravno u postojeći `flex justify-between` red.
 */
const AxisLabels: React.FC<AxisLabelsProps> = ({ labels, className = "text-sm text-slate-400", denseThreshold = 10 }) => {
  const n = labels.length;
  if (n === 0) return null;

  if (n > denseThreshold) {
    return (
      <>
        <span className={`${className} truncate`}>{labels[0]}</span>
        <span className={`${className} truncate`}>{labels[n - 1]}</span>
      </>
    );
  }

  return (
    <>
      {labels.map((l, i) => (
        <span key={i} className={`${className} flex-1 text-center truncate`}>
          {thinLabel(l, i, n)}
        </span>
      ))}
    </>
  );
};

export default AxisLabels;
